import { render, staticRenderFns } from "./gwAIAssistant.vue?vue&type=template&id=487e6d9c&scoped=true"
import script from "./gwAIAssistant.vue?vue&type=script&lang=js"
export * from "./gwAIAssistant.vue?vue&type=script&lang=js"
import style0 from "./gwAIAssistant.vue?vue&type=style&index=0&id=487e6d9c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487e6d9c",
  null
  
)

export default component.exports